// extracted by mini-css-extract-plugin
export default {"h1":"C5otGrTsmYjfx7vCPcQp","h2":"LBVrnxOYCRh_x_NaZG0F"};